<script setup lang="ts">
import SyncVisitConnectButton from '@components/syncVisit/SyncVisitConnectButton.vue';
import { useQuizStore, useUserStore } from '@stores/index';

const emit = defineEmits<{
  next: [],
}>();

const quizStore = useQuizStore();
const userStore = useUserStore();
</script>

<template>
  <div class="quiz-qualify">
    <div class="f-row">
      <div class="f-col-8 flex flex-col items-center">
        <SyncVisitConnectButton
          v-if="userStore.info?.id"
          :patient-id="userStore.info.id"
          :submission-id="quizStore.submissionId"
        />
      </div>
    </div>
  </div>
</template>
